/**
 * Screen Widgt Function Just Create Dimensions Box With Screen Sizes 
 */

export function screenWidgt (){
    if (process.env.NODE_ENV === "development") {
        $('<div />').attr('id', 'screen-widght').appendTo('body').css({
            position: 'fixed',
            bottom: 5,
            right: 5,
            border: '1px solid white',
            padding: '4px',
            color: 'white',
            zIndex: 1000,
            background : "#000"
        }).text($(window).width() + ' x ' + $(window).height());
    
    
        $(window).on('resize', function () {
            $('#width').html($(window).width() + ' x ' + $(window).height());
        });
    }
    

}

export function destroyScreenWidght(){
    $('#screen-widght').fadeOut('fast').remove();
}


// WEBPACK FOOTER //
// ./modules/screenWidgt.js